module.exports = __webpack_public_path__ + "img/Au-Sable-Highbanks-Overlook.dfe871a5.jpg";